import { GET } from "./api";

export const Read = async (companyId) => {
  return await GET(
    `/audit-logs?filters[company][id][$eq]=${companyId}&populate[user]=*&populate[company]=*&sort[createdAt]=desc`,
    true
  );
};

export const ReadWithPagination = async (companyId, page, pageSize = 25) => {
  return await GET(
    `/audit-logs?filters[company][id][$eq]=${companyId}&populate[user]=*&populate[company]=*&sort[createdAt]=desc&pagination[page]=${page}&pagination[pageSize]=${pageSize}`,
    true
  );
};

export const ReadAction = async (companyId) => {
  return await GET(`/audit-logs/latest-uploads?companyId=${companyId}`, true);
};
